<template>
  <div v-if="sendForApproval" class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <InertiaLink class="btn btn-block btn-primary mb-2" :href="route('asset.approval', [assetType.slug, asset])">
          {{ label }}
        </InertiaLink>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from './Mixin';

export default {
  mixins: [Mixin],

  computed: {
    label() {
      this.areAllActionsAccepted();

      if (this.state.withCounterparty && this.allActionsAccepted) {
        return 'Send to someone else to Sign';
      }

      return this.state.state === 'signed' ? 'Send to someone else to Sign' : 'Send for Approval';
    },

    sendForApproval() {
      const showForStates = [
        'editing',
        'pending',
        'signed',
      ];

      if (showForStates.includes(this.state.state)) {
        return this.userHasPermissionTo('send_for_approval');
      }

      return false;
    },
  },
};
</script>
